import AlertBadge from 'components/Alerts/AlertBadge';
export const columns = [
    
    {
        Header: 'Device Type',
        accessor: 'device_type',
    },
    {
        Header: 'Level',
        accessor: 'level',
        component: (item) => { 
            let alertType = "alarm";
            let alertText = "alarm";
            if (item.level === "fault") {
                alertType = "fault";
                alertText = "fault";
            }  
            return (
                <AlertBadge type={alertType} text={alertText} />
            );
        },
    },
    {
        Header: 'Message',
        accessor: 'message',
    },
    
    {
        Header: 'Start Time',
        accessor: 'start_time_formatted', 
    },
     {
        Header: 'End Time',
        accessor: 'end_time_formatted', 
    },
];
